export default "__VITE_ASSET__ef956220__"